import React from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import {SMALL_DEVICE_MEDIA_SIZE} from "components/common/constants";
import {DatePicker, MobileDatePicker} from "@mui/x-date-pickers";
import {useTheme} from "@mui/material";

export default function ResponsiveDatePicker(props) {
    const theme = useTheme();
    const isSmallDevice = useMediaQuery(theme.breakpoints.down(SMALL_DEVICE_MEDIA_SIZE));
    if(isSmallDevice) {
        return <MobileDatePicker {...props} />;
    } else {
        return <DatePicker {...props} />;
    }
}
